import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path d="M28.831,26.433H8.706V15.232h20.125V26.433z M10.706,24.433h16.125v-7.201H10.706V24.433z" />
    <path fill="none" strokeWidth="2" strokeMiterlimit="10" d="M28.043,20.833" />
    <path
      d="M29.043,21.833c-0.552,0-1-0.448-1-1s0.448-1,1-1c2.099,0,3.806-2.166,3.806-4.827c0-1.325-0.419-2.562-1.179-3.484
      c-0.714-0.866-1.647-1.343-2.626-1.343c0,0,0,0-0.001,0H9.757c-0.552,0-1-0.448-1-1s0.448-1,1-1h19.286c0,0,0,0,0.001,0
      c1.587,0,3.068,0.735,4.169,2.07c1.055,1.279,1.636,2.968,1.636,4.756C34.85,18.77,32.245,21.832,29.043,21.833z"
    />
    <path
      d="M28.748,33.663c0,0-19.819-0.028-19.99-0.01c-2.952-0.002-5.348-3.067-5.345-6.832c0.001-1.771,0.524-3.446,1.474-4.717
      c1.014-1.358,2.389-2.106,3.871-2.106c0.001,0,0.002,0,0.004,0l-0.002,2c0,0-0.001,0-0.001,0c-0.836,0-1.642,0.462-2.269,1.303
      c-0.693,0.928-1.075,2.179-1.076,3.521c-0.001,2.615,1.527,4.826,3.339,4.831l19.997,0.01L28.748,33.663z"
    />
    <path d="M28.706,35.583l0.002-5.846l5.054,2.923L28.706,35.583z M29.947,31.886 M29.946,33.435" />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Flow.jsx